<template>
  <div>
    <CommonSection />
    <div class="container-fluid">
      <v-row>
        <v-col>
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <h3 class="mb-0 float-left card-header-name">User Management</h3>
              <router-link :to="{ path: 'user/create' }" class="float-right mt-0">
                <v-tooltip bottom :color="$vuetify.theme.themes.light.tooltipColor">
                  <template v-slot:activator="{ on: tooltip, attrs }">
                    <img
                      class="mr-2"
                      v-bind="attrs"
                      v-on="{ ...tooltip }"
                      src="@/assets/images/Plus.svg"
                    />
                  </template>
                  <span>Add User</span>
                </v-tooltip>
              </router-link>
            </div>
            <v-card>
              <v-card-title>
                <v-row>
                  <v-col>
                    <v-text-field
                      class="search-text-field"
                      v-model="search"
                      append-icon="search"
                      label="Search by Email, First Name, Last Name"
                      single-line
                      hide-details
                      v-debounce:1s="searchFilter"
                      :debounce-events="['click', 'keydown']"
                    ></v-text-field>
                  </v-col>

                  <v-col>
                    <v-select
                      :items="statusArr"
                      item-value="value"
                      item-text="name"
                      label="Select Status"
                      v-model="status"
                      @change="statusFilter"
                    ></v-select>
                  </v-col>

                  <v-col>
                    <v-select
                      :items="profileStatusArr"
                      item-value="value"
                      item-text="name"
                      label="Select Registration Status"
                      v-model="profileStatus"
                      @change="statusFilter"
                    ></v-select>
                  </v-col>

                  <v-col>
                    <v-select
                      :items="roles"
                      item-value="_id"
                      item-text="name"
                      label="Select Role"
                      v-model="role"
                      @change="statusFilter"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-card-title>
              <v-data-table
                :headers="headers"
                :items="users"
                :loading="loading"
                loading-text="Loading... Please wait"
                :page.sync="page"
                :items-per-page="itemsPerPage"
                hide-default-footer
              >

                <template v-slot:[`item.firstName`]="{ item }">
                  {{ item.firstName ? item.firstName : '-' }}
                </template>
                
                <template v-slot:[`item.lastName`]="{ item }">
                  {{ item.lastName ? item.lastName : '-' }}
                </template>

                <template v-slot:[`item.roles.name`]="{ item }">
                  <div>
                    {{
                    item.roles && item.roles.name
                    ? item.roles.name
                    : "-"
                    }}
                  </div>
                </template>

                <template v-slot:[`item.step`]="{ item }">
                  {{ item.step === 3 ? 'Completed' : 'Not-Completed' }}
                </template>

                <template v-slot:[`item.isActive`]="{ item }">
                  <v-chip
                    label
                    :color="getColor(item)"
                    dark
                    v-if="!item.isDelete"
                  >{{ item.isActive? 'Active' : 'Inactive' }}</v-chip>
                  <v-chip
                    label
                    class="mx-2"
                    v-if="item.isDelete"
                    :color="getColor(item)"
                    dark
                  >{{ item.isDelete? 'Deleted' : 'no' }}</v-chip>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <v-tooltip bottom :color="$vuetify.theme.themes.light.tooltipColor">
                    <template v-slot:activator="{ on: tooltip, attrs }">
                      <img
                        v-bind="attrs"
                        v-on="{ ...tooltip }"
                        class="mr-2 edit-icon"
                        @click="editItem(item)"
                        src="@/assets/images/Edit.svg"
                      />
                    </template>
                    <span>Edit</span>
                  </v-tooltip>
                  <delete-user
                    :id="item._id"
                    :isDelete="item.isDelete"
                    @requestDeleted="requestDeleted"
                    @isLoading="isLoading"
                  ></delete-user>
                </template>
              </v-data-table>
              <v-card-actions class="justify-end pt-2">
                <v-pagination circle v-model="page" :length="pageCount" :total-visible="7"></v-pagination>
              </v-card-actions>
            </v-card>
          </card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import CommonSection from "@/components/CommonHeader";
import { UserService } from "@/services";

export default {
  name: "Users",
  components: {
    CommonSection,
    DeleteUser: () => import("@/components/DeleteUser"),
  },
  data: () => ({
    page: 1,
    pageCount: 0,
    loading: true,
    itemsPerPage: 50,
    search: null,
    users: [],
    roles: [],
    role: null,
    status: null,
    profileStatus: null,
    statusArr: [
      {
        name: "All",
        value: "",
      },
      {
        name: "Active",
        value: "isActive",
      },
      {
        name: "Deleted",
        value: "isDeleted",
      },
      {
        name: "Inactive",
        value: "isInactive",
      },
    ],
    profileStatusArr: [
      {
        name: "All",
        value: "",
      },
      {
        name: "Completed",
        value: "completed",
      },
      {
        name: "Not-Completed",
        value: "notCompleted",
      },
    ],
    headers: [
      {
        text: "Email",
        align: "start",
        value: "email",
      },
      { text: "First Name", value: "firstName" },
      { text: "Last Name", value: "lastName" },
      { text: "Role", value: "roles.name" },
      { text: "Profile Status", value: "step" },
      { text: "Status", value: "isActive" },
      { text: "Actions", value: "actions", sortable: false },
    ],
  }),
  watch: {
    page() {
      this.initialize();
    },
    status(value){
      if (value === "isDeleted") {
        //  this.headers.pop()  
      }
      else{
       let columnList = this.headers.map(header => header.value);
        if(!columnList.includes("actions")){
          this.headers.push({ text: "Actions", value: "actions", sortable: false })
        }
      } 
    }
  },
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      const roleNames = await UserService.getRolesList();
      this.roles = roleNames.data.data.filter((element) => {
        return element.active === true;
      });
      this.roles.unshift({ name: "All", _id: "", active: true });
      this.loading = true;
      const params = {
        limit: parseInt(this.itemsPerPage),
        skip:
          parseInt(this.page) * parseInt(this.itemsPerPage) -
          parseInt(this.itemsPerPage),
        search: this.search,
      };
      if (this.status === "isDeleted") {
        params.isDelete = true;
      } else if (this.status === "isActive") {
        params.active = true;
      } else if (this.status === "isInactive") {
        params.active = false;
      }
      if (this.profileStatus === "completed") {
        params.step = "completed";
      } else if (this.profileStatus === "notCompleted") {
        params.step = "notCompleted";
      }
      if (this.role) {
        params.role = this.role;
      }
      const UserList = await UserService.UsersList(params);
      if (UserList.data.data.length > 0) {
        this.pageCount = Math.ceil(
          UserList.data.option[0].count / this.itemsPerPage
        );
        this.users = UserList.data.data;
        this.loading = false;
      } else {
        if (this.page !== 1) {
          this.page--;
        }
        this.loading = false;
        this.users = [];
      }
    },
    getColor(object) {
      if (object.isActive) {
        return "#30E362";
      } else if (object.isDelete) {
        return "red";
      } else {
        return "#5B5B5B";
      }
    },
    async editItem(value) {
      this.$router.push("user/" + value._id);
    },
    searchFilter() {
      this.page = 1;
      this.initialize();
    },
    statusFilter() {
      this.page = 1;
      this.initialize();
    },
    requestDeleted() {
      this.initialize();
    },
    isLoading() {
      this.loading = true;
    },
  },
};
</script>